import { createContext } from "react";

import { ParsedUnacknowledgedLevel } from "../hooks/useGetUnacknowledgedLevels";

type LevelCongratulationsContext = {
  currentUnacknowledgedLevel: ParsedUnacknowledgedLevel | null;
  acknowledgeLevel: (levelId: string, levelGroupId: string) => void;
  areStatusesPending: boolean;
};

export const initialLevelCongratulationsContextData: LevelCongratulationsContext = {
  currentUnacknowledgedLevel: null,
  acknowledgeLevel: notImplemented,
  areStatusesPending: false,
};

export const levelCongratulationsContext = createContext<LevelCongratulationsContext>(
  initialLevelCongratulationsContextData
);

function notImplemented(): never {
  throw new Error("Missing LevelCongratulationsProvider");
}
